import React from "react";
import PropTypes from "prop-types";

import ErrorDisplayContainer from "../grundelemente/ErrorDisplayContainer";

import VerbundKompressorContainer from "./VerbundKompressorContainer";

const Verbundsteuerung = (props) => (
	<div>
		{ props.compressors.map((compressor, index) => (
			<VerbundKompressorContainer key={index}
				compressor={compressor} lindex={index}/>
		))}
		<ErrorDisplayContainer component={-1} />
	</div>
);

Verbundsteuerung.propTypes = {
	compressors: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Verbundsteuerung;
